import React, { useState } from 'react';
import { useAnim, useSEO } from "../hooks.jsx";
import { CellVal } from "../icons.jsx";
import { COMPARE, PAGE_SEO, SCHEMA_PREZZI, BREADCRUMBS, BREADCRUMB_ITEMS } from "../data.js";
import Breadcrumb from "../components/Breadcrumb.jsx";
import PriceCard from "../components/PriceCard.jsx";
import GuideLinks from "../components/GuideLinks.jsx";

const QUICK_FAQ = [
  { q:"Il Base include dominio e hosting?",  a:"No. Il piano Base funziona all'indirizzo noleggioincloud.app/nome-del-tuo-noleggio ed è pensato per chi ha fino a 10 veicoli. Per il dominio personalizzato serve il Business Pro." },
  { q:"Il Pro include dominio e hosting?",  a:"No. Il piano Pro funziona all'indirizzo noleggioincloud.app/nome-del-tuo-noleggio. Per il dominio personalizzato (es. tuonoleggio.it) e l'hosting dedicato serve il Business Pro." },
  { q:"La personalizzazione del sito è inclusa nel Pro?", a:"No. La personalizzazione completa del sito (logo, colori, dominio e brand) è disponibile solo nel piano Business Pro." },
  { q:"Cosa succede dopo i 14 giorni?",     a:"I tuoi dati rimangono al sicuro. Ti chiediamo di scegliere un piano (Base, Pro o Business Pro) per continuare ad usare la piattaforma." },
  { q:"Posso cambiare piano in seguito?",   a:"Sì, in qualsiasi momento. Upgrade e downgrade sono immediati senza perdita di dati." },
  { q:"Come funziona il database?",         a:"Il piano Base include 2 GB, il Pro 5 GB, il Business Pro 10 GB. Per tutti i piani è disponibile un addon di +5 GB aggiuntivi a +5€/mese." },
  { q:"Ci sono costi aggiuntivi Stripe?",   a:"Stripe applica la sua commissione standard (es. 1.5% + 0.25€) sulle transazioni. Noi non addebitiamo nulla in più." },
];

export default function Prezzi({ go }) {
  const [isAnnual, setIsAnnual] = useState(false);
  useAnim();
  useSEO({ ...PAGE_SEO.prezzi, schema: [SCHEMA_PREZZI, BREADCRUMBS.prezzi] });

  return (
    <>
      <Breadcrumb items={BREADCRUMB_ITEMS.prezzi} />
      <section className="ph">
        <div className="ph-in an">
          <div className="chip">Prezzi</div>
          <h1 className="h2" style={{ fontSize:"clamp(1.9rem,4vw,2.9rem)" }}>
            Prezzi del gestionale<br /><mark>semplici e trasparenti</mark>
          </h1>
          <p className="lead" style={{ marginTop:".65rem", marginBottom:"2rem" }}>
            14 giorni di prova gratuita con le funzionalità del piano Pro, nessuna carta richiesta.
            Poi scegli il piano più adatto alla tua attività.
          </p>


          <div style={{ display:"flex", justifyContent:"center", marginTop:"1.5rem" }}>
            <div style={{
              display:"inline-flex", alignItems:"center", gap:".35rem",
              background:"var(--bg2)", padding:".35rem",
              borderRadius:"12px", border:"1.5px solid var(--border)",
              boxShadow:"inset 0 1px 3px rgba(15,23,42,.06)"
            }}>
              <button
                onClick={() => setIsAnnual(false)}
                style={{
                  background: !isAnnual ? '#fff' : 'transparent',
                  boxShadow: !isAnnual ? '0 1px 4px rgba(15,23,42,.1)' : 'none',
                  color: !isAnnual ? 'var(--ink)' : 'var(--muted)',
                  border: 'none', cursor: 'pointer',
                  padding: '.5rem 1.15rem', borderRadius: '9px',
                  fontFamily: "'Plus Jakarta Sans',sans-serif",
                  fontWeight: 700, fontSize: '.85rem',
                  transition: 'all .22s ease',
                }}
              >
                Mensile
              </button>
              <button
                onClick={() => setIsAnnual(true)}
                style={{
                  background: isAnnual ? '#fff' : 'transparent',
                  boxShadow: isAnnual ? '0 1px 4px rgba(15,23,42,.1)' : 'none',
                  color: isAnnual ? 'var(--blue-dk)' : 'var(--muted)',
                  border: 'none', cursor: 'pointer',
                  padding: '.5rem 1.15rem', borderRadius: '9px',
                  fontFamily: "'Plus Jakarta Sans',sans-serif",
                  fontWeight: 700, fontSize: '.85rem',
                  display: 'flex', alignItems: 'center', gap: '.5rem',
                  transition: 'all .22s ease',
                }}
              >
                Annuale
                <span style={{
                  background:"var(--green-lt)", color:"var(--green)",
                  padding:".15rem .6rem", borderRadius:"99px",
                  fontSize:".72rem", fontWeight:700,
                  border:"1px solid rgba(22,163,74,.2)"
                }}>2 mesi gratis</span>
              </button>
            </div>
          </div>

        </div>
      </section>

      <section className="sec" style={{ background:"var(--bg)" }}>
        <div className="wrap">

          {/* ── Pricing grid ── */}
          <div className="pg">

            {/* BASE */}
            <PriceCard
              tier="Base"
              price={isAnnual ? "349" : "34,99"}
              period={isAnnual ? "all'anno + IVA" : "al mese + IVA"}
              note={<>Ideale per chi gestisce <strong>fino a 10 veicoli</strong>. <strong>34,99€/mese</strong> (o 349€/anno).</>}
              noteVariant="default"
              items={[
                { ok:true,  label:<>Auto <strong>e</strong> Moto incluse</> },
                { ok:true,  label:<>Fino a <strong>10 veicoli</strong></> },
                { ok:true,  label:<><strong>2 GB</strong> database inclusi · +5€/mese per +5 GB</> },
                { ok:true,  label:"Sito di prenotazione online" },
                { ok:true,  label:"Pagamenti online Stripe" },
                { ok:true,  label:"Contratti PDF automatici" },
                { ok:true,  label:"1 Admin" },
                { ok:true,  label:"Assistenza via email e chat WhatsApp" },
                { ok:false, label:"Codici sconto non inclusi" },
                { ok:false, label:"Statistiche avanzate non incluse" },
                { ok:false, label:"Dominio personalizzato non incluso" },
              ]}
              ctaLabel="Scegli il piano Base"
              ctaVariant="primary"
              ctaHref="/register?plan=base"
            />

            {/* PRO */}
            <PriceCard
              featured
              tag="14 giorni gratis inclusi"
              tagVariant="free"
              tier="Pro"
              price={isAnnual ? "899" : "89,99"}
              period={isAnnual ? "all'anno + IVA" : "al mese + IVA"}
              note={<>Il piano più completo senza dominio proprio. <strong>Prova gratis 14 giorni</strong>, poi <strong>89,99€/mese</strong> (o 899€/anno). Il sito è raggiungibile su noleggioincloud.app/il-tuo-nome — per il dominio proprio serve Business Pro.</>}
              noteVariant="default"
              items={[
                { ok:true,  label:<><strong>14 giorni gratis</strong> · nessuna carta</> },
                { ok:true,  label:<>Auto <strong>e</strong> Moto incluse</> },
                { ok:true,  label:<>Fino a <strong>40 veicoli</strong></> },
                { ok:true,  label:<><strong>5 GB</strong> database inclusi · +5€/mese per +5 GB</> },
                { ok:true,  label:"Sito di prenotazione online" },
                { ok:true,  label:"Pagamenti online Stripe" },
                { ok:true,  label:"Contratti PDF automatici" },
                { ok:true,  label:"Statistiche e ricavi" },
                { ok:true,  label:"Codici sconto" },
                { ok:true,  label:"Admin illimitati" },
                { ok:true,  label:"Onboarding assistito" },
                { ok:true,  label:"Assistenza via email e chat WhatsApp" },
                { ok:true,  label:"SLA 99.90%" },
                { ok:false, label:"Dominio personalizzato non incluso" },
                { ok:false, label:"Hosting non incluso" },
              ]}
              ctaLabel="Scegli il piano Pro"
              ctaVariant="outline"
              ctaHref="/register?plan=pro"
            />

            {/* BUSINESS PRO */}
            <PriceCard
              tag="Dominio + Hosting inclusi"
              tagVariant="best"
              tier="Business Pro"
              price={isAnnual ? "1.690" : "169"}
              period={isAnnual ? "all'anno + IVA" : "al mese + IVA"}
              note={<>Include <strong>dominio personalizzato</strong> e <strong>hosting dedicato</strong>. Il tuo sito sarà raggiungibile direttamente su <em>tuonoleggio.it</em>.</>}
              noteVariant="ok"
              items={[
                { ok:true, label:<>Auto <strong>e</strong> Moto incluse</> },
                { ok:true, label:<>Veicoli <strong>illimitati</strong></> },
                { ok:true, label:<><strong>10 GB</strong> database inclusi · +5€/mese per +5 GB</> },
                { ok:true, label:"Tutto incluso nel piano Pro" },
                { ok:true, label:<><strong>Dominio personalizzato</strong> incluso</> },
                { ok:true, label:<><strong>Hosting dedicato</strong> incluso</> },
                { ok:true, label:<><strong>Personalizzazione sito</strong> (logo, colori, brand)</> },
                { ok:true, label:"Onboarding assistito" },
                { ok:true, label:"Assistenza via email e chat WhatsApp" },
                { ok:true, label:<>SLA <strong>99.95%</strong> garantito</> },
              ]}
              ctaLabel="Scegli Business Pro"
              ctaVariant="outline"
              ctaHref="/register?plan=business"
            />
          </div>

          {/* ── Compare table ── */}
          <div className="ctw an" style={{ marginTop:"4rem" }}>
            <div className="cth">
              <div>Funzionalità</div>
              <div>Base — {isAnnual ? '€349/anno' : '€34,99/mese'}</div>
              <div>Pro — {isAnnual ? '€899/anno' : '€89,99/mese'}</div>
              <div>Business Pro — {isAnnual ? '€1.690/anno' : '€169/mese'}</div>
            </div>
            {COMPARE.map(r => (
              <div className="ctr" key={r.f}>
                <div>{r.f}</div>
                <div><CellVal v={r.base} /></div>
                <div><CellVal v={r.pro} /></div>
                <div><CellVal v={r.biz} /></div>
              </div>
            ))}
          </div>

          {/* ── Quick FAQ ── */}
          <div className="an" style={{ marginTop:"3.5rem", background:"#fff", border:"1.5px solid var(--border)", borderRadius:"var(--rl)", padding:"2.25rem" }}>
            <h3 className="j" style={{ fontSize:"1.15rem", fontWeight:800, color:"var(--ink)", marginBottom:"1.5rem" }}>
              Domande sui piani
            </h3>
            <div className="qfaq-grid">
              {QUICK_FAQ.map(x => (
                <div key={x.q} style={{ borderLeft:"3px solid var(--blue)", paddingLeft:"1rem" }}>
                  <div className="j" style={{ fontWeight:700, fontSize:".9rem", color:"var(--ink)", marginBottom:".3rem" }}>{x.q}</div>
                  <div style={{ fontSize:".85rem", color:"var(--muted)", lineHeight:1.65 }}>{x.a}</div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </section>

      <GuideLinks />
    </>
  );
}
